<template>
  <div>
    <div class="content" style="width:auto">
      <div class="cont-list">
        <span class="list">{{ this.parentRoute.menuName }}-{{ title }}产品信息维护</span>
      </div>

      <el-form label-position="top" label-width="80px" ref="form" :model="form" :rules="rules">
        <div class="edit-card">
          <div style="width:88%;display: flex">
            <div class="start-label" />
            <span class="text">原产品信息</span>
          </div>
          <el-row>
            <el-col :span="4">
              <el-form-item label="产品编号" prop="oldNo">
                <el-input disabled v-model="form.oldNo" style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="单件产品名称" prop="oldName">
                <el-input v-model="form.oldName" disabled style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="产品注册证" prop="oldProductRegistCertName">
                <el-input v-model="form.oldProductRegistCertName" disabled style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="注册证号" prop="oldProductRegistCertNo">
                <el-input v-model="form.oldProductRegistCertNo" disabled style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="生产厂家" prop="oldManufacturerName">
                <el-input v-model="form.oldManufacturerName" disabled style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="售后代理商">
                <el-input v-model="form.oldAgentName" disabled style="width:100%"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          
          <el-row>
            <el-col :span="4">
              <el-form-item label="规格型号" prop="oldSpecName">
                <el-input v-model="form.oldSpecName" disabled style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="医保耗材代码" prop="oldMedicalInsuranceCategoryId">
                <el-input v-model="form.oldMedicalInsuranceCategoryId" disabled style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="一级分类">
                <el-input disabled v-model="form.oldFirstCategory" style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="二级分类">
                <el-input disabled v-model="form.oldSecondCategory" style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="三级分类">
                <el-input disabled v-model="form.oldThirdCategory" style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="医保通用名" prop="oldCommonName">
                <el-input v-model="form.oldCommonName" disabled style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="材质" prop="oldTexture">
                <el-input v-model="form.oldTexture" disabled style="width:100%"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4">
              <el-form-item label="特征" prop="oldProperties">
                <el-input v-model="form.oldProperties" disabled style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="oldProductionRangeName" label="生产范围">
                <el-select v-model="form.oldProductionRangeName" class="oldProduction" disabled value-key="id" multiple style="width:100%">
                  <el-option v-for="item in STATIC_ProductionRanges" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <div class="edit-card" style="margin-top: 10px; padding-bottom: 10px">
          <div style="width:88%;display: flex">
            <div class="start-label" />
            <span class="text">产品信息</span>
          </div>

          <el-row>
            <el-col :span="4">
              <el-form-item label="单件产品名称" prop="name">
                <el-input v-model="form.name" disabled :class="Boolean(form.oldId)&& form.name!= form.oldName? 'change-content' : ''" style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="产品注册证" prop="productRegistCertName">
                <el-input v-model="form.productRegistCertName" disabled :class="Boolean(form.oldId)&& form.productRegistCertName!= form.oldProductRegistCertName? 'change-content' : ''" style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="注册证号" prop="productRegistCertNo">
                <el-input v-model="form.productRegistCertNo" disabled :class="Boolean(form.oldId)&& form.productRegistCertNo!= form.oldProductRegistCertNo? 'change-content' : ''" style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="生产厂家" prop="manufacturerName">
                <el-input v-model="form.manufacturerName" disabled :class="Boolean(form.oldId)&& form.manufacturerName!= form.oldManufacturerName? 'change-content' : ''" style="width:100%"></el-input>
              </el-form-item>
            </el-col>
              <el-col :span="4">
              <el-form-item label="售后代理商" >
                <el-input v-model="form.agentName" disabled :class="Boolean(form.oldId)&& form.manufacturerName!= form.oldManufacturerName? 'change-content' : ''" style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="规格型号" prop="specName">
                <el-input v-model="form.specName" disabled :class="Boolean(form.oldId)&& form.specName!= form.oldSpecName? 'change-content' : ''" style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="医保耗材代码" :class="Boolean(form.oldId)&& form.medicalInsuranceCategoryId!= form.oldMedicalInsuranceCategoryId? 'change-content' : ''" prop="medicalInsuranceCategoryId">
                <el-input v-model="form.medicalInsuranceCategoryNo" disabled style="width:100%"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="4">
              <el-form-item label="一级分类">
                <el-input disabled v-model="form.firstCategory" :class="Boolean(form.oldId)&& form.firstCategory!= form.oldFirstCategory? 'change-content' : ''" style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="二级分类">
                <el-input disabled v-model="form.secondCategory" :class="Boolean(form.oldId)&& form.secondCategory!= form.oldSecondCategory? 'change-content' : ''" style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="三级分类">
                <el-input disabled v-model="form.thirdCategory" :class="Boolean(form.oldId)&& form.thirdCategory!= form.oldThirdCategory? 'change-content' : ''" style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="医保通用名" prop="commonName">
                <el-input v-model="form.commonName" disabled :class="Boolean(form.oldId)&& form.commonName!= form.oldCommonName? 'change-content' : ''" style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="材质" prop="texture">
                <el-input v-model="form.texture" disabled :class="Boolean(form.oldId)&& form.texture!= form.oldTexture? 'change-content' : ''" style="width:100%"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="4">
              <el-form-item label="特征" prop="properties">
                <el-input v-model="form.properties" disabled :class="Boolean(form.oldId)&& form.properties!= form.oldProperties? 'change-content' : ''" style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="productionRangeName" label="生产范围">
                <el-select v-model="form.productionRangeName" class="oldProduction" disabled :class="Boolean(form.oldId)&& form.productionRangeIds!= form.oldProductionRangeIds? 'change-content' : ''" value-key="id" multiple style="width:100%">
                  <el-option v-for="item in STATIC_ProductionRanges" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="备注" prop="remark">
                <el-input v-model="form.remark" :disabled="!editMode" placeholder="请填写备注" resize="none" type="textarea" :rows="5" style="width:100%"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item prop="fileInfos" label="">
                <UploadFileList label="上传附件" :fileList="form.fileInfos ? form.fileInfos : []" btnShowType="always" :multipleFile="false" :showFileList="true" :editMode="editMode" @fileChange="filesChange"></UploadFileList>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <ApproveInfo ref="approveInfo" v-if="showWorkFlowInfo" @change="approveInfoChange"></ApproveInfo>
      </el-form>
    </div>
    <div slot="footer" class="footer-bottom"><el-button v-if="editMode" class="btn default" v-preventReClick @click="cancel">取 消</el-button>
      <my-button v-if="editMode" class="btn primary" type="primary" v-preventReClick @click="submit">确 定</my-button>
      <my-button v-if="showWorkFlowInfo" class="btn primary" type="primary" v-preventReClick @click="approve">确 定</my-button>
      <el-button v-if="!editMode" class="btn default" v-preventReClick @click="cancel">返 回</el-button>
      <!-- <el-button class="btn default" v-preventReClick @click="cancel">取 消</el-button>
      <my-button class="btn primary" type="primary" v-if="editMode" v-preventReClick @click="submit">确 定</my-button> -->
    </div>
    <!-- <el-image-viewer :openViewer="dialogVisible" :fileId="fileId" :fileName="fileName" @closeImageViewer="closeImageViewer" /> -->
  </div>
</template>

<script>
import GetDataMixin from "@/mixin/getData-mixin.js";
import {
  GetProductUpdateById,
  SaveProductUpdate,
  RejectProductUpdate
} from "@/api";
import {
  // SupplierCategoryOptions,
  // LevelOptions,
  // ManufacturerCertificateOptions,
} from "@/enum";
// import Address from "@/components/address";
// import MyUpload from "@/components/my-upload";
// import ElImageViewer from "@/components/elImageViewer";
import ApproveInfo from "@/components/approve-info";
import UploadFileList from "@/components/upload-file-list";

export default {
  name: "manufacturerUpdateEdit",
  mixins: [GetDataMixin],
  components: {
    // Address,
    // MyUpload,
    // ElImageViewer,
    ApproveInfo,
    UploadFileList
  },
  data () {
    return {
      reject: RejectProductUpdate,

      title: "",
      form: {},
      // 生产厂商证件类型
      // ManufacturerCertificateOptions: ManufacturerCertificateOptions,
      // SupplierCategoryOptions: SupplierCategoryOptions,
      // LevelOptions: LevelOptions,
      rules: {
        name: [
          { required: true, message: "产品名称不能为空", trigger: "blur" },
        ],
        // productionRangeName: [
        //   { required: true, message: '请选择生产范围', trigger: 'blur' }
        // ],
      },
      editMode: false
    };
  },
  props: {
  },
  created () {
    var query = this.$route.query;
    if (query.id) {
      this.handleUpdate(query.id);
    } else {
      this.handleAdd();
    }

    this.getProductionRanges('')
  },
  methods: {
    // 新建
    handleAdd () {
      this.title = "新建";
      this.resetForm();
      this.editMode = true;
    },
    // 编辑
    handleUpdate (id) {
      GetProductUpdateById({ id }).then((res) => {
        this.resetForm()
        this.form = res.returnData;
        this.title = "编辑";
        // this.form.category = this.form.category.split(';')
        // this.form.oldCategory = this.form.oldCategory ? this.form.oldCategory.split(';') : []


        if (this.form.productionRangeInfos) {
          let arr = this.form.productionRangeInfos.map(item => {
            var range = this.STATIC_ProductionRanges.filter(e => e.id == item.id)
            if (!range || range.length == 0) {
              this.STATIC_ProductionRanges.push(item)
            }

            return item.id * 1
          })
          this.$set(this.form, 'productionRangeName', [...arr])
        }
        if (this.form.oldProductionRangeInfos) {
          let oldArr = this.form.oldProductionRangeInfos.map(item => {
            var range = this.STATIC_ProductionRanges.filter(e => e.id == item.id)
            if (!range || range.length == 0) {
              this.STATIC_ProductionRanges.push(item)
            }

            return item.id * 1
          })
          this.$set(this.form, 'oldProductionRangeName', [...oldArr])
        }

        // this.editMode = false;
        // if (this.formMode == 2) {
        //   this.editMode = true;
        // }

        this.initWorkFlowProperty(this.form);
      });
    },
    // 保存
    submit () {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return false;
        }
        // this.form.category = this.form.category.join(';')
        // this.form.oldCategory = this.form.oldCategory.join(';')

        SaveProductUpdate(this.form).then((res) => {
          this.$my_message(`执行成功`, "success");
          sessionStorage.setItem("editMode", 0);
          // this.$router.push({ path: this.getMainPath(this.$route.path) });
          this.routePushWithParams(this.getMainPath(this.$route.path), this.$route.params);
        })
        .finally(() => {
            this.$store.dispatch('SetLoading',false)
        });
      });
    },
    resetForm () {
      this.form = {
        name: "",
        state: 1,
        countryId: 0,
        provinceId: 0,
        cityId: 0,
        details: [],
        productionRangeName: [],
        productionRangeId: '',
        orgCode :sessionStorage.getItem('orgId'),
      };
    },
       // 取消编辑
    cancel () { 
      this.$store.dispatch('SetLoading',false)
      // this.$my_confirm("确认要中断当前操作吗？", "提示", {
      //   type: "warning",
      // }).then(() => {
      //   });
      // this.$router.push({ path: this.getMainPath(this.$route.path) });
      this.routePushWithParams(this.getMainPath(this.$route.path), this.$route.params);
    },
    rangeChange (val) {
      this.form['productionRangeIds'] = val ? val.join(';') : ''
    },

    // 上传附件
    filesChange (fileList) {
      this.form.fileInfos = fileList;
    },
  },
};
</script>

<style lang="scss" scoped>
.oldProduction {
  width: 100%;
  max-height: 120px;
  overflow-x: hidden;

  /deep/.el-select__tags {
    max-height: 120px !important;
  }
}
</style>
